{
    "DataTable_AreYouSure": "Tem certeza de que deseja excluir o seguinte? \n \n **{}**",
    "NAME": "LanguageDataTable"
}